export default {"src":"/_next/static/media/KeepaLogoWhite.f8909afb.svg","height":113,"width":280};